if (!customElements.get('product-form')) {
  
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
                	 /*  const divToCapture = document.getElementById('letterList');
                       html2canvas(divToCapture, {
                        useCORS: true,
                        ignoreElements: function (element) {
                            // Ignore problematic elements
                            return element.tagName === "FORM" || element.tagName === "IFRAME";
                        }
                    }).then(canvas => {
                        const imageData = canvas.toDataURL('image/png');
                        document.getElementById('hiddenImageInput').value = '<img src="'+imageData+'"/>';
                    }).catch(err => {
                        console.error('Error capturing the div:', err);
                    }); */
        evt.preventDefault();

        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        // Name block configurator: only present in the main product section
        const configurator = this.getConfiguratorData();
        if (configurator && configurator.error) {
          this.handleErrorMessage(configurator.error);
          return;
        }

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
      //  console.log(formData);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

        // Add the configurator details for every cart type (drawer, notification or page)
        if (configurator) {
          formData.set('id', configurator.variantId);

          const images = configurator.section.querySelectorAll('#letterList img');
          
          // Extract their src attributes
          const imageUrls = Array.from(images).map(img => img.src);
         // formData.append('custom_text1', formData.get('properties[Custom Message]'));
          const name = document.getElementById('inputText').value;
        //  const final_img = document.getElementById('hiddenImageInput').value;
        //  alert(final_img);
        //  const custom_price = document.getElementById('adjusted_price').value;
        //  const shape = document.querySelector('input[name="properties[additional_shape]"]:checked').value;
        // Collect all checked checkboxes
          const checkboxes = document.querySelectorAll('input[name="properties[additional_shape]"]:checked');
          const properties = {};
          var add_block = "";
          checkboxes.forEach((checkbox) => {
            if(checkbox.value!=""){
              add_block += checkbox.value+",";
            }
          });
          if (add_block.endsWith(',')) {
              add_block = add_block.slice(0, -1); // Removes the last character
          }
     
          let color = document.getElementById('selected_colors').value;
          const size = configurator.size;
          const count = configurator.blockCount;
		  /*color = color.replace(/,([^,]*)$/, '$1');
          const num_block = color;
          const values = num_block.split(","); // Split the string by commas
          const count = values.length; // Get the number of items */
          
          formData.append('properties[Personalisation]', name);
          formData.append('properties[Block Size]', size);
          formData.append('properties[No. Blocks]', count);
          formData.append('properties[SKU]', size+","+name.toUpperCase()+","+color);
          //formData.append('properties[Color]', color);
          if(add_block!=""){
            formData.append('properties[Shape Blocks]', add_block);
          }
       //  formData.append('properties[Photo]', final_img);
          
         // Add each image URL as a separate property
imageUrls.forEach((url, index) => {
  formData.append(`properties[Block Letter ${index + 1}]`, url);
});
         // formData.append('properties[Blocks]', imageUrls.join(' '));
        }
        config.body = formData;

      //  const customMessage = formData.get('properties[Custom Message]');
        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
               //  customMessage : formData.get('properties[Custom Message]'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }
dataURLtoBlob(dataURL) {
        const arr = dataURL.split(',');
        const mime = arr[0].match(/:(.*?);/)[1];
        const bstr = atob(arr[1]);
        let n = bstr.length;
        const u8arr = new Uint8Array(n);
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }
        return new Blob([u8arr], { type: mime });
    }
      // Returns null when this form has no name block configurator (e.g. quick add, featured product).
      // Otherwise returns the block count, size and the variant matching them, or an error message.
      getConfiguratorData() {
        const section = this.closest('product-info');
        const input = section && section.querySelector('#inputText');
        if (!input) return null;

        const letterCount = input.value.replace(/\s+/g, '').length;
        const shapeCount = section.querySelectorAll('.shape_input:checked').length;
        const blockCount = letterCount + shapeCount;
        if (blockCount === 0) {
          return { error: 'Please enter the name or text for your blocks, or choose a shape block.' };
        }

        const sizeInput = section.querySelector('input[name="properties[block_size]"]:checked');
        const size = sizeInput ? sizeInput.value : '4.3 cm';
        const optionValue = (size === '7.0 cm' ? '70mm' : '43mm') + blockCount;

        const variantsJson = section.querySelector('[data-name-block-variants]');
        const variants = variantsJson ? JSON.parse(variantsJson.textContent) : [];
        const variant = variants.find((v) => v.options.includes(optionValue));
        if (!variant || !variant.available) {
          return { error: 'Sorry, this block size and number of blocks is currently unavailable.' };
        }

        return { section, size, blockCount, variantId: variant.id };
      }
      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }
      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
